import { render, staticRenderFns } from "./CustomerHomeLayout.vue?vue&type=template&id=616da064&scoped=true&"
import script from "./CustomerHomeLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerHomeLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHomeLayout.vue?vue&type=style&index=0&id=616da064&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616da064",
  null
  
)

export default component.exports